import { render, staticRenderFns } from "./UITextField.vue?vue&type=template&id=4e57022e&"
import script from "./UITextField.vue?vue&type=script&lang=js&"
export * from "./UITextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports